import { client } from "api";
import { MinimalOrder } from "models/MinimalOrder";

export type GetAssignedOrdersRequest = { completed?: boolean };

export type GetAssignedOrdersResponse = MinimalOrder[];

export const getAssignedOrders = (params?: GetAssignedOrdersRequest) =>
  client.get<GetAssignedOrdersResponse>(`/order/assigned`, { params }).then((res) => res.data);
